export const GET_QUOTE = "GET_QUOTE";
export const ADD_FAV = "ADD_FAV";
export const GET_FAVS = "GET_FAVS";
export const REMOVE_FAV = "REMOVE_FAV";
export const GET_QUOTEBYSEARCH = "GET_QUOTEBYSEARCH";
export const RESTORE = "RESTORE";
